type PublicConfig = {
  apiBaseUrl: string;
  scopedWebPath: string;
  eventsPath: string;
  termsUrl: string;
  privacyUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
};

function required(value: string | undefined, name: string): string {
  if (!value || value.trim() === '') {
    throw new Error(`Missing required env value ${name}`);
  }
  return value.trim();
}

function normalizeBaseUrl(value: string): string {
  return value.replace(/\/+$/, '');
}

function normalizePath(value: string): string {
  const trimmed = value.trim();
  if (!trimmed.startsWith('/')) {
    return `/${trimmed}`.replace(/\/+$/, '');
  }
  return trimmed.replace(/\/+$/, '');
}

export const publicConfig: PublicConfig = {
  apiBaseUrl: normalizeBaseUrl(required(import.meta.env.VITE_API_BASE_URL, 'VITE_API_BASE_URL')),
  scopedWebPath: normalizePath(
    required(import.meta.env.VITE_SCOPED_WEB_PATH, 'VITE_SCOPED_WEB_PATH'),
  ),
  eventsPath: normalizePath(required(import.meta.env.VITE_EVENTS_PATH, 'VITE_EVENTS_PATH')),
  termsUrl: required(import.meta.env.VITE_TERMS_URL, 'VITE_TERMS_URL'),
  privacyUrl: required(import.meta.env.VITE_PRIVACY_URL, 'VITE_PRIVACY_URL'),
  appStoreUrl: required(import.meta.env.VITE_APP_STORE_URL, 'VITE_APP_STORE_URL'),
  playStoreUrl: import.meta.env.VITE_PLAY_STORE_URL?.trim() ?? '',
};
